import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './print-styles.css';
const PrintContainer = ({ children }) => {
    const [container, setContainer] = useState(null);
    useEffect(() => {
        // Create a container div that lives outside the main DOM hierarchy
        const printContainer = document.createElement('div');
        printContainer.style.position = 'absolute';
        printContainer.style.width = '0';
        printContainer.style.height = '0';
        printContainer.style.overflow = 'hidden';
        printContainer.style.left = '-9999px';
        printContainer.className = 'print-container';
        // Append to body, outside of main app container
        document.body.appendChild(printContainer);
        setContainer(printContainer);
        return () => {
            document.body.removeChild(printContainer);
        };
    }, []);
    if (!container)
        return null;
    // Use portal to render children into the separate container
    return ReactDOM.createPortal(children, container);
};
export default PrintContainer;
